import Promise from 'bluebird';
import { getRouterDep } from '@bingads-webui-campaign-react/legacy-router-dep';
import cacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
/* eslint-disable import/extensions */

/* eslint-disable import/no-unresolved */
import * as spaFactory from '@bingads-webui-campaign-legacy/import-campaigns/spa/index';

export function loadLegacyDeps(legacyParams, requireGapi = true) {
  return new Promise((resolve) => {
    if (requireGapi === true) {
      const css = document.createElement('link');
      css.type = 'text/css';
      css.href = 'https://fonts.googleapis.com/css?family=Roboto';
      css.rel = 'stylesheet';
      document.getElementsByTagName('head')[0].appendChild(css);

      window.require(requireGapi ? ['ext/google/gsi'] : [], () => {
        resolve(spaFactory);
      });
    } else {
      resolve(spaFactory);
    }
  });
}

export function createCommonDeps({
  permissions,
  scope,
  siteMap,
  data,
  preferenceService,
}) {
  return {
    adGroupMedium: `Search${permissions.IsUserContentAllowed ? 'AndContent' : ''}`,
    language: data.language,
    market: data.market,
    storeList: data.storeList,
    showPayment: data.showPayment,
    paymentMethodUrl: data.paymentMethodUrl,
    sharedCookieDomain: data.sharedCookieDomain,
    token: data.token,
    isForVNext: true,
    router: getRouterDep(scope, siteMap),
    CampaignCacheManager: cacheManager,
    preferenceService,
  };
}
